import { Dimensions } from "react-native";

const window = Dimensions.get("window");

export const styleConstants = {
  windowWidth: window.width,
  windowHeight: window.height,
  colorBackgroundWhite: "#FFFFFF",
  colorBackgroundLight: "#F3F9FC",
  colorBackgroundLightDark: "#E8F4F9",
  colorBackgroundLightDarker: "#C5E3F1",
  colorBackgroundTheme: "#178EC6",
  colorBackgroundThemeSoft: "#499FC9",
  colorBackgroundDarkLighter: "#1580B2",
  colorBackgroundDarkLight: "#12729E",
  colorBackgroundDark: "#051C28",
  colorBackgroundBlack: "#000000",

  colorBackgroundDanger: "#C93E4D",
  colorBackgroundWarning: "#E3844A",
  colorBackgroundSuccess: "#408F42",
  colorBackgroundGray: "#C7C7C7",
  colorBackgroundDisabled: "#E4E4E4",
  colorBackgroundBackdrop: "rgba(56, 56, 56, 0.7)",
  colorBackgroundBackdropWhite: "rgba(251, 242, 246, 0.60)",

  colorTextDark: "#051C28",
  colorTextDarkSoft: "rgba(5, 28, 40, 0.72)",
  colorTextDarkSofter: "rgba(5, 28, 40, 0.4)",

  colorTextLight: "#F3F9FC",
  colorTextLightSoft: "rgba(243, 249, 252, 0.72)",
  colorTextLightSofter: "rgba(243, 249, 252, 0.4)",

  colorTextTheme: "#178EC6",
  colorTextDanger: "#C93E4D",
  colorTextSuccess: "#408F42",
  colorTextWarning: "#E3844A",
  colorTextDisabled: "#C7C7C7",

  spacingExtraSmall: 4,
  spacingSmall: 8,
  spacingMedium: 12,
  spacingLarge: 16,
  spacingExtraLarge: 24,
  spacingExtraExtraLarge: 32,

  fontSizeExtraSmall: 12,
  fontSizeSmall: 14,
  fontSizeMedium: 16,
  fontSizeLarge: 20,
  fontSizeExtraLarge: 24,

  borderRadiusSmall: 4,
  borderRadiusMedium: 8,
  borderRadiusLarge: 16,
};
